let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hwa3A")).then(() => parcelRequire('7hsCB'));